<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchTitle"></breadcrumb-search>
      <div style="display: flex; padding-bottom: 24px">
        <div v-for="(item, index) in records" :key="index" class="record-item">
          <div>
            <img style="width: 56px; height: 56px" :src="item.img" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-if="false">
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          size="small"
        >
          <el-form-item label="下单用户" prop="goodsName">
            <el-input
              placeholder="请输入用户信息"
              v-model="searchForm.userInfo"
            ></el-input>
          </el-form-item>
          <el-form-item label="订单编号" prop="goodsName">
            <el-input
              placeholder="请输入订单编号"
              v-model="searchForm.orderNo"
            ></el-input>
          </el-form-item>
          <el-form-item label="订单日期" prop="createdTimeStart">
            <el-date-picker
              v-model="value1"
              style="width: 232px"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.settleStatus"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option label="未到账" value="1"></el-option>
              <el-option label="已到账" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-btn">
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>月度统计</h3>
        <div>
          <el-button
            type="primary"
            @click="todetail"
            >佣金明细</el-button
          >
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="commissionList"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data () {
    return {
      searchForm: {
        userInfo: '',
        orderNo: '',
        pageNo: 1,
        pageSize: 10,
        orderTimeStart: '',
        orderTimeEnd: '',
        settleStatus: ''
      },
      dataList: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '平台佣金', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {
          img: require('../../../assets/icon_yongjin.png'),
          title: '佣金总数',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_daijiesuan.png'),
          title: '冻结中',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_yitixian.png'),
          title: '分享身份佣金总数',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_shengyu.png'),
          title: '分享礼包佣金总数',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_shengyu.png'),
          title: '分享商品佣金总数',
          price: '10000'
        }
      ],
      searchTitle: {
        list: [
          { title: '佣金记录', path: '', type: '0' }
        ]
      },
      value1: [],
      brandList: [],
      columns: [
        {
          label: '佣金月份', prop: 'orderUsername'
        },
        { label: '佣金总数', prop: 'orderNo' },
        { label: '冻结中', prop: 'orderNo' },
        { label: '分享身份佣金总数', prop: 'orderTime' },
        { label: '分享礼包佣金总数', prop: 'orderAmount' },
        { label: '分享商品佣金总数', prop: 'discountAmount' },
        {
          label: '操作', prop: 'settleStatusLabel', minWidth: '100',
          render: (h, scope) => {
            
            return (
              <div> 查看详情</div>
            )

          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      commissionList: [],
      exporting: false
    }
  },
  created () {
    this.getCommissionStatistics()
    this.getCommissionPageList()
  },
  methods: {
    exportCommissionList () {
      this.exporting = true;
      this.axios.post('/platforms/exportCommissionList',this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code == 0) {
            this.downloadlink(res.data)
          }
        })
    },
    handleSizeChange (e) {
      this.page.pageNo = 1;
      this.page.pageSize = e;
      this.getCommissionPageList()
    },
    handleCurrentChange (e) {
      this.page.pageNo = e;
      this.getCommissionPageList()
    },
    onMultipleSelection (e) { },
    fetchData (val) {
      this.page.pageNo = 1
      if (val == 'reset') {
        this.searchForm.userInfo=''
        this.searchForm.orderNo=''
        this.searchForm.settleStatus=''
        this.value1 = []
        this.searchForm.orderTimeStart = ''
        this.searchForm.orderTimeEnd = ''
      }
      this.getCommissionPageList()
    },
    getCommissionPageList () {
      // let data = {
      //   pageNo: this.page.pageNo,
      //   pageSize: this.page.pageSize
      // }
      if (this.value1) {
        this.searchForm.orderTimeStart = this.value1[0]
        this.searchForm.orderTimeEnd = this.value1[1]
      } else {
        this.searchForm.orderTimeStart = ''
        this.searchForm.orderTimeEnd = ''
      }
      this.searchForm.pageNo = this.page.pageNo
      this.searchForm.pageSize = this.page.pageSize
      this.axios.post('/platforms/getCommissionPageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              if (!item.settleTime) {
                item.settleTime = '--'
              }
            })
            this.commissionList = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    getCommissionStatistics () {
      this.axios.get('/platforms/getCommissionStatistics')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records[0].price = res.data.totalCommission;
            this.records[1].price = res.data.awaitCommission;
            this.records[2].price = res.data.paidCommission;
            this.records[3].price = res.data.activeCommission;
          }
        })
    },
    todetail () {
      this.$router.push({
        name: 'commissionDetail',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 6px;
  margin-right: 18px;
  img {
    padding: 16px 14px;
  }
  .right {
    margin-top: 16px;
    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }
    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }
  }
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
/deep/ .el-table {
  color: #303033;
}
</style>

